<template>
  <section class="events-list">
    <!-- Lista de Eventos -->
    <v-row>
      <v-col cols="12" md="10" v-for="(event, index) in events" :key="index" class="event-wrapper">
        <div class="event-container" @click="!event.preferencial_date_start ? editEvent(event) : null">
          <!-- Cartão do evento -->
          <v-card flat :class="['event-card', getCardClass(event)]">
            <div class="event-content">
              <p class="event-title">
                <!-- 
                    MC-337 - Alice Serina - 10/02/2026
                    There is no need to use JS to truncate the title, we can do it with pure CSS using text-overflow: ellipsis.
                -->
                <strong class="event-title-text">{{ event.title }}</strong>
                <span class="participants">
                  <span class="participants-count">{{ event.n_participants || 0 }}</span>
                  <v-icon class="participants-icon">mdi-account</v-icon>
                </span>
                
              </p>
              <p v-if="!event.preferencial_date_start" class="event-description">{{ truncateText(event.description, 120) }}</p>
              <p
                v-if="event.preferencial_date_start"
                @click.stop="confirmReopenEvent(event.id)"
                class="event-description closed"
              >
              <span>Data Fechada</span>
              <br>
              <span>
                {{ 
                    event.duration_type !== 'hours' ? `${formatDate(event.preferencial_date_start)} - ${formatDate(event.preferencial_date_end)}` : formatEventHours(event.preferencial_date_start, event.preferencial_date_end)
                }}                
              </span>
              </p>
            </div>
          </v-card>

         <!-- Botão de Apagar -->
         <v-btn icon class="delete-btn" @click.stop="confirmDeleteEvent(event.id)" style="color: black; opacity: 0.5">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <DialogConfirmation
      v-if="dialogVisible"
      v-model="dialogVisible"
      type="warning"
      @on-cancel="closeDialog"
      @on-submit="proceedDeleteEvent"
    >
      Tem certeza que deseja sair deste evento?
    </DialogConfirmation>

    <DialogConfirmation
      v-if="dialogReopenVisible"
      v-model="dialogReopenVisible"
      type="warning"
      @on-cancel="closeReopenDialog"
      @on-submit="proceedReopenEvent"
    >
      Deseja reativar este evento?
    </DialogConfirmation>


    <!-- ISTO SO APARECE SE FOR MOBILE. A CLASS d-sm-none FAZ COM QUE SO APAREÇA EM MOBILE -->
    <div class="d-sm-none mobile-padding"></div>
  </section>
</template>
  
  <script>
  import Events from '@/api/Events.js';
  import DialogConfirmation from '@/components/ui/DialogConfirmation.vue';

  export default {
    components: {
      DialogConfirmation
    },

    props: {
      events: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        confirmDelete: null, 
        dialogVisible: false,
        confirmReopen: null,
        dialogReopenVisible: false
      };
    },
    computed:{      
      isMobile() {
        return window.innerWidth <= 1460;
      },
    },
    methods: {

      formatEventHours(startStr, endStr) {
          const start = new Date(startStr);
          const end = new Date(endStr);

          const day = String(start.getDate()).padStart(2, '0');
          const month = String(start.getMonth() + 1).padStart(2, '0');
          const year = start.getFullYear();

          const startHour = String(start.getHours()).padStart(2, '0');
          const startMin = String(start.getMinutes()).padStart(2, '0');
          const endHour = String(end.getHours()).padStart(2, '0');
          const endMin = String(end.getMinutes()).padStart(2, '0');

          return `${day}/${month}/${year} ${startHour}:${startMin} - ${endHour}:${endMin}`;
        },
      truncateText(text, maxLength = 100) {
        if (!text) return '';
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
      },

      limitTitle(text) {
          // const maxLength = 30; // Define o limite máximo de caracteres para truncar
          // if (!text) return ''; // Se não houver texto, retorna uma string vazia
          // return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
          return this.truncateText(text, 30);
      },

      limitTitleMobile(text) {
          // const maxLength = 12; // Define o limite máximo de caracteres para truncar
          // if (!text) return ''; // Se não houver texto, retorna uma string vazia
          // return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
          return this.truncateText(text, 12);
      },

      getCardClass(event) {
          if (event.preferencial_date_start) {
              return 'transparent-card';
          } else if (event.allAgree) {
              return 'green-card';
          } else {
              return 'closed-card';
          }
      },
      editEvent(event) {
          this.$emit('editEvent', event);
      },
      
    // Abre o modal de confirm
    confirmDeleteEvent(eventId) {
      this.confirmDelete = eventId;
      this.dialogVisible = true;
    },

    // Fecha o modal sem apagar o evento
    closeDialog() {
      this.dialogVisible = false;
      this.confirmDelete = null;
    },

    confirmReopenEvent(eventId) {
      this.confirmReopen = eventId;
      this.dialogReopenVisible = true;
    },

    closeReopenDialog() {
      this.dialogReopenVisible = false;
      this.confirmReopen = null;
    },

 
    // Apaga o evento se for confirmado
    async proceedDeleteEvent() {
      if (!this.confirmDelete) return;

      try {
        await Events.delete(this.confirmDelete);
        this.$emit('eventDeleted');
      } catch (error) {
        console.error('Erro ao apagar evento:', error);
      }

      this.closeDialog();
    },

    async proceedReopenEvent() {
      try {
        await Events.reopen(this.confirmReopen);
        this.$emit('eventDeleted')
        this.closeReopenDialog();
      } catch (error) {
        console.log("Erro ao reabrir evento:", error.response?.data || error);
      }
    },
    }
  };
  </script>
  
  <style scoped>

@media (max-width: 600px) {
    .mobile-padding{
        padding-bottom: 100px; /* Aumenta o espaço apenas no mobile */
    }

    .v-application p {
      margin-bottom: 0;
    }
    
}
    .participants {
        font-size: 0.9em;
        color: gray;
    }

    .closed-date {
        color: rgb(0, 0, 0);
        text-align: center;
    }

    .delete-btn {
        margin-left: 10px;
    }

    .closed-card {
        background-color: rgba(255, 255, 255, 0.4); /* Opaco */
    }

    .green-card {
        background-color: #cbd8c7; 
    }

    .transparent-card {
        background-color: transparent;
        border: 1px solid #000000;
    }
    


  </style>